"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _configureTypekit = _interopRequireDefault(require("../../utils/configureTypekit"));

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _intl = require("../../utils/intl");

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _state = require("../../Toast/js/state");

require("../../focus-ring-polyfill");

require("../style/index.css");

var _class, _class2, _temp;

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/page/index.css");

  require("../../spectrum-css/page/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/page/index-lg.css");
} else {
  require("../../spectrum-css/page/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/page/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/page/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/page/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/page/multiStops/darkest.css");

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/typography/index.css");

  require("../../spectrum-css-overrides/typography/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/typography/index-lg.css");
} else {
  require("../../spectrum-css-overrides/typography/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css-overrides/typography/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css-overrides/typography/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css-overrides/typography/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css-overrides/typography/multiStops/darkest.css");

var Provider = (0, _convertUnsafeMethod["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Provider, _Component);

  // Expose the current theme etc. on the context for children to read if needed.
  function Provider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Provider);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Provider).call(this, props));
    (0, _intl.setLocale)(props.locale);

    if (process.browser) {
      (0, _configureTypekit["default"])(props.typekitId);
    }

    if (props.toastPlacement) {
      (0, _state.setToastPlacement)(props.toastPlacement);
    }

    return _this;
  }

  (0, _createClass2["default"])(Provider, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('locale' in nextProps) {
        (0, _intl.setLocale)(nextProps.locale);
      }

      if (nextProps.toastPlacement) {
        (0, _state.setToastPlacement)(nextProps.toastPlacement);
      }
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        theme: this.props.theme,
        scale: this.props.scale,
        locale: this.props.locale
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          children = _this$props.children,
          scale = _this$props.scale,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["theme", "className", "children", "scale"]);
      return _react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _classnames["default"])(className, 'react-spectrum-provider', 'spectrum', "spectrum--".concat(theme), "spectrum--".concat(scale))
      }, (0, _filterDOMProps["default"])(props)), children);
    }
  }]);
  return Provider;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /**
   * Theme.
   */
  theme: _propTypes["default"].oneOf(['light', 'lightest', 'dark', 'darkest']),

  /**
   * Scale.
   */
  scale: _propTypes["default"].oneOf(['medium', 'large']),

  /**
   * The placement of the toasts. By default position is top- shorthand for "top center".
   */
  toastPlacement: _propTypes["default"].oneOf(['top', 'top left', 'top center', 'top right', 'bottom', 'bottom left', 'bottom center', 'bottom right']),

  /**
   * Type kit ID. This is required and products must get their own id's.
   * https://typekit.com/account/kits
   * There is a default provided, but it's only intended for prototyping work.
   */
  typekitId: _propTypes["default"].string,

  /**
   * Locale, takes format primary-region ex. en-US, cs-CZ
   */
  locale: _propTypes["default"].string,

  /**
   * CSS class name.
   */
  className: _propTypes["default"].string
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  theme: 'light',
  scale: 'medium',
  typekitId: 'ruf7eed',
  locale: _intl.defaultLocale
}), (0, _defineProperty2["default"])(_class2, "childContextTypes", {
  theme: _propTypes["default"].oneOf(['light', 'lightest', 'dark', 'darkest']),
  scale: _propTypes["default"].oneOf(['medium', 'large']),
  locale: _propTypes["default"].string
}), _temp)) || _class;

exports["default"] = Provider;